<template>
  <el-card shadow="always" :body-style="{ padding: '20px', height: '72vh' }">
    <div slot="header">
      <div class="flex" style="justify-content: space-between;">
        <div>
          <img src="@/assets/home/new.png" alt="" />
          <span class="hardtext">构件厂概况</span>
        </div>
        <el-button
          type="primary"
          @click="
            dialogVisible = true;
            addOrupdate = true;
            form.fileListQy = [];
            form.imageUrlQy = '';
            form.link = '';
          "
          >添加</el-button
        >
      </div>
    </div>
    <!-- card body -->
    <div>
      <el-table
        align="center"
        stripe
        :data="tableData"
        :header-cell-style="{
          background: '#EBEFF2',
          color: '#1E2134',
          fontWeight: 'bold',
        }"
      >
        <el-table-column
          align="center"
          type="index"
          label="序号"
          width="80"
        ></el-table-column>
        <el-table-column align="center" label="图片">
          <template slot-scope="scope">
            <el-image
              :src="$store.state.baseUrl + scope.row.pjov03"
              style="width: 40px;"
              :preview-src-list="scope.row.srcList"
            ></el-image>
          </template>
        </el-table-column>
        <el-table-column align="center" label="跳转链接">
          <template slot-scope="scope"
            ><a :href="scope.row.pjov04" target="_blank">{{
              scope.row.pjov04
            }}</a></template
          >
        </el-table-column>
        <el-table-column align="center" label="发布时间" prop="pjov05">
        </el-table-column>
        <el-table-column align="center" label="发布人" prop="pjov06">
        </el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button type="primary" size="small" @click="updateGK(scope.row)"
              >编辑</el-button
            >
            <el-popconfirm
              title="确定删除这条数据吗？"
              @confirm="delGK(scope.row)"
            >
              <el-button
                style="margin-left: 10px;"
                slot="reference"
                type="danger"
                size="small"
                >删除</el-button
              >
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        align="right"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 30, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
    <el-dialog
      :title="addOrupdate ? '添加' : '编辑'"
      :visible.sync="dialogVisible"
      width="35%"
    >
      <div style="width: 50%">
        <el-form ref="form" :model="form" label-width="130px">
          <el-form-item label="图片" class="comUpload">
            <el-upload
              style="width: 386px"
              class="upload-demo"
              drag
              action="#"
              :limit="1"
              :on-change="handleChangeQy"
              :auto-upload="false"
              :file-list="form.fileListQy"
            >
              <img
                v-if="form.imageUrlQy"
                :src="form.imageUrlQy"
                class="avatar width200p"
                style="width: 360px; height: 140px"
              />
              <div v-else>
                <div style="margin-top: 30px" class="el-upload__text">
                  <em>点击上传</em>&nbsp; / &nbsp;拖拽到此区域
                </div>
                <div style="margin-top: -1px" class="el-upload__text textStyle">
                  为保证最佳显示效果，请上传3:1比例的图片
                </div>
              </div>
            </el-upload>
          </el-form-item>
          <el-form-item label="跳转链接">
            <el-input
              style="width: 386px"
              placeholder="请输入内容"
              v-model="form.link"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item style="text-align: center">
                <el-button size="small">取消</el-button>
                <el-button
                  type="primary"
                  size="small"
                  @click="addEnterprise('form')"
                  >保存</el-button
                >
              </el-form-item> -->
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addEnterprise('form')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </el-card>
</template>

<script>
import {
  insertpjoveriver,
  deletepjoveriver,
  updatepjoveriver,
  GetpjoveriverList,
} from "@/setAxios";
import dayjs from "dayjs";
export default {
  name: "RunhongXUGK",
  data() {
    return {
      dialogVisible: false,
      form: {
        fileListQy: [],
        imageUrlQy: "",
        link: "",
      },
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      addOrupdate: true,
      updateNew: "",
    };
  },

  mounted() {},
  created() {
    this.GetpjoveriverList();
  },
  methods: {
    handleChangeQy(file, fileList) {
      this.form.fileListQy = fileList.slice(-3);
    },
    delGK(row) {
      deletepjoveriver({ id: row.pjov01 }).then((res) => {
        if (res.Code > 0) {
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        }
        this.GetpjoveriverList();
      });
    },
    updateGK(row) {
      this.updateNew = row;
      this.addOrupdate = false;
      this.dialogVisible = true;
      this.form.fileListQy = [];
      this.form.imageUrlQy = this.$store.state.baseUrl + row.pjov03;
      this.form.link = row.pjov04;
    },
    // 提交
    async addEnterprise() {
      this.UploadFileFrom = new FormData();
      if (this.form.fileListQy.length > 0) {
        this.form.fileListQy.forEach((file) => {
          this.UploadFileFrom.append("file", file.raw);
        });
      } else {
        if (this.addOrupdate) {
          this.UploadFileFrom.append("file", null);
          this.$message({
            type: "warning",
            message: "文件未上传!",
          });
          return;
        }
      }
      let res;
      if (this.addOrupdate) {
        this.UploadFileFrom.append("url", this.form.link);
        this.UploadFileFrom.append("uid", this.$store.state.uid);
        this.UploadFileFrom.append("xid", this.$store.state.xid);
        res = await insertpjoveriver(this.UploadFileFrom);
      } else {
        this.UploadFileFrom.append("pjov04", this.form.link);
        this.UploadFileFrom.append("pjov01", this.updateNew.pjov01);
        this.UploadFileFrom.append("pjov03", this.updateNew.pjov03);
        this.UploadFileFrom.append("pjov02", this.$store.state.xid);
        res = await updatepjoveriver(this.UploadFileFrom);
      }
      if (res.Code > 0) {
        this.$message({
          type: "success",
          message: this.addOrupdate ? "添加" : "编辑" + "成功!",
        });
        this.dialogVisible = false;
        this.GetpjoveriverList();
      } else {
        this.$message({
          type: "error",
          message: "操作有误!",
        });
      }
    },
    //列表
    async GetpjoveriverList() {
      let params = {
        xid: this.$store.state.xid,
        pageIndex: this.currentPage,
        pageSize: this.pageSize,
      };
      let res = await GetpjoveriverList({ params });
      res.Data.list.forEach((element) => {
        element.pjov05 = dayjs(element.pjov05).format("YYYY年MM月DD日");
        element.srcList = ["" + this.$store.state.baseUrl + element.pjov03];
      });
      this.tableData = res.Data.list;
      this.total = res.Data.total;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.GetpjoveriverList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.GetpjoveriverList();
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .comUpload .el-upload-dragger {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 386px;
}
/deep/.el-upload-dragger .textStyle {
  font-size: 12px;
  color: #d9d9d9;
}
</style>
